import Switch from 'react-switch';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
// import swal from '@sweetalert/with-react';
import Swal from 'sweetalert2'

import _ from 'lodash';

import { Button, LinearProgress as LoadingOverlay } from '@material-ui/core';
import {
  DataGridPro, useGridApiRef, GridFooter, GridFilterInputValue, frFR, enUS,
  GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton
} from '@mui/x-data-grid-pro';

import Print from './Print';
import Export from './Export';
import Create from './Create';
import Update from './Update';

import { create } from '../../../../Functions/admin';
import { useReportingContext } from '../../../../Context/Reporting/Provider';
import { useAppContext } from '../../../../Context/App/Provider';
import { get, update, remove } from '../../../../Functions/admin';
import { useAdminContext } from '../../../../Context/Admin/Provider';
import { useEventContext } from '../../../../Context/Event/Provider';
import { colors, roles, sharingValues, devicesTypeValues, useStateWithCallback, toastTimerValue } from '../../../../Shared/utils';
import { changeAdminColumns, changeSettings, activeGridFilter, translatedGridFilters } from '../../../../Functions/utils';

import { updateReportColumnsOrder } from '../../../../Functions/user';
import { decodeHTMLEntities } from '../../../../Functions/utils';
import { getReports } from '../../../../Functions/reporting';

import '../Admin.css';
import '../../../SweetAlert.css'

export default function ReportsList() {
  const { t } = useTranslation();
  const apiRef = useGridApiRef();
  // const [{ reportColumns }, dispatch] = useAdminContext();
  const [{ settings, user }, appDispatch] = useAppContext();
  const [{ selected }, dispatch] = useReportingContext();
  const [{ reportsStatus }, eventDispatch] = useEventContext();

  // const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reports, setReports] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [reportGeneratorDataLoaded, setReportGeneratorDataLoaded] = useState(false);
  const [reportGeneratorData, setReportGeneratorData] = useState({});

  // const [databV2, setDatabV2] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [model, setModel] = useStateWithCallback({ filtered: null, selected: [] });

  const [reordering, setReordering] = useState(null);
  // const [reorderedColumns, setReorderedColumns] = useState({});
  const [reorderedColumn, setReorderedColumn] = useState("");
  const [oldIndex, setOldIndex] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);

  const [loadedColumnsFromDatabase, setLoadedColumnsFromDatabase] = useState(false);
  const [reportColumnsFromDatabase, setReportColumnsFromDatabase] = useState({});

  const [highlightedRow, setHighlightedRow] = useState(null);

  const [modeReports, setModeReports] = useState(
    /*settings.mode === 'all_reports' ||
    settings.mode === 'myShared_scenarios' ||
    settings.mode === 'myPrivate_scenarios' ||
    settings.mode === 'sft_scenarios' ||
    settings.mode === 'allGroups_scenarios' ||
    settings.mode === 'currentGroups_scenarios' ? settings.mode :*/ 'all_reports'
  );

  const handleSetModeReports = (mode) => {
    setModeReports(mode);
    document.querySelector('#modeReports').classList.toggle('open');
  };



  useEffect(() => {
    if (!loadedColumnsFromDatabase) {
      setLoadedColumnsFromDatabase(true);

      const reportColumnsOrder = user.reportColumnsOrder ? JSON.parse(user.reportColumnsOrder) : {};
      // console.log("111 - reportColumnsOrder=", reportColumnsOrder);

      const allReportColumns = {
        id: { hide: true, order: 1, width: 100 },
        enabled: { hide: true, order: 2, width: 100 },
        favorite: { hide: false, order: 3, width: 50 },
        type: { hide: false, order: 4, width: 140 },
        name: { hide: false, order: 5, width: 250 },
        template: { hide: false, order: 6, width: 250 },
        version: { hide: false, order: 7, width: 160 },
        format: { hide: false, order: 8, width: 140 },
        language: { hide: false, order: 9, width: 140 },
        pageSize: { hide: false, order: 10, width: 140 },
        orientation: { hide: false, order: 11, width: 200 },
        dateFormat: { hide: false, order: 12, width: 200 },
        outputFileName: { hide: false, order: 13, width: 300 },
        creator: { hide: false, order: 14, width: 200 },
        sharingOptions: { hide: false, order: 15, width: 300 },
        group: { hide: false, order: 16, width: 200 },
        owner: { hide: false, order: 17, width: 350 },
        creationDate: { hide: false, order: 18, width: 200 },
        lastEditionUser: { hide: false, order: 19, width: 350 },
        lastEditionDate: { hide: false, order: 20, width: 200 },
        percentUsage: { hide: false, order: 21, width: 350 },
        actions: { hide: false, order: 22, width: 150 }
      }

      // console.log("163 - allReportColumns=", allReportColumns);

      for (const key of Object.keys(allReportColumns)) {
        if (reportColumnsOrder[key]) {
          allReportColumns[key] = reportColumnsOrder[key];
        }
      }
      // console.log("173 - allReportColumns=", allReportColumns);

      const orderedKeys = Object.keys(allReportColumns)
        .sort((a, b) => {
          return allReportColumns[a].order > allReportColumns[b].order ? 1 : -1;
        });
      // console.log("173 - orderedKeys=", orderedKeys);

      let i = 1;
      for (const key of orderedKeys) {
        allReportColumns[key].order = i;
        i++;
      }
      // console.log("113 - allReportColumns=", allReportColumns);
      setReportColumnsFromDatabase(allReportColumns);
    }
  }, [loadedColumnsFromDatabase]);



  useEffect(() => {
    if (!reportGeneratorDataLoaded) {
      setReportGeneratorDataLoaded(true);
      get({ type: 'reportgenerator' }).then(res => {
        if (!res.success)
          return;

        setReportGeneratorData(res.reportGeneratorData);
      });
    }
  }, []);



  useEffect(() => {
    const dropdown = (e) => {
      if (typeof e.target.className === 'string' && !e.target.className.includes('dropdown')) {
        document.querySelector('#modeReports') && document.querySelector('#modeReports').classList.remove('open');
      }
    };
    document.addEventListener('click', dropdown);
    return () => document.removeEventListener('click', dropdown);
  }, [t]);



  useEffect(() => {
    document.title = t('admin.reports.page');

    if (!loaded) get({ type: 'report' }).then(res => {
      setLoading(false);

      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.reports.errors.' + res)), { type: 'error' });
      }

      const newReports = [];
      for (const report of res.reports) {

        let arrayGroup = new Array();
        if (report.group)
          arrayGroup.push(report.group);
        report.groups = arrayGroup;

        newReports.push(report);
      };
      setReports(newReports);
      setLoaded(true);
    });
  }, [t, loaded]);



  useEffect(() => {
    get({ type: 'reportgenerator' }).then(res => {
      if (!res.success)
        return;

      setReportGeneratorData(res.reportGeneratorData);
    });
  }, []);



  useEffect(() => {
    apiRef.current.subscribeEvent('columnHeaderDragStart', (params) => {
      setReordering(true);
      setReorderedColumn("");
      setOldIndex(null);
      setTargetIndex(null);
    });

    apiRef.current.subscribeEvent('columnHeaderDragEnd', (params) => {
      setReordering(false);
    });
  }, [apiRef]);



  useEffect(() => {
    if (reordering === false) {
      changeColumnsOrder(reorderedColumn, oldIndex, targetIndex);
      setReordering(null);
    }
  }, [reordering]);




  let columns = [];

  if (reportColumnsFromDatabase.id) {
  if (user.roleId <= roles.stAdmin) {

    columns = [ // default visible width: 1650
      {
        field: 'id',
        headerName: 'ID',
        hide: reportColumnsFromDatabase.id.hide,
        filterable: false,
        width: reportColumnsFromDatabase.id.width
      },
      {
          // sortable: false,
        field: 'enabled',
        type: 'activeFilter',
        hide: reportColumnsFromDatabase.enabled.hide,
        width: reportColumnsFromDatabase.enabled.width,
        headerName: t('admin.reports.columns.active'),

        renderCell: ({ row }) => {
          const icon = (
            <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
              <circle r={3.5} cx={5} cy={5} />
            </svg>
          );

          return (
            <Switch
              disabled={loading || (row.sharingOptions === sharingValues.everyone && user.roleId > roles.stAdmin)}
              checked={row.enabled}
              onChange={() => toggleActivated(row)}
              offHandleColor="#888" onHandleColor="#080"

              checkedIcon={null} uncheckedIcon={null}
              checkedHandleIcon={icon} uncheckedHandleIcon={icon}
            />
          );
        }
      },
      {
          // sortable: false,
        field: 'favorite',
        // type: 'activeFilter',
        hide: reportColumnsFromDatabase.favorite.hide,
        width: reportColumnsFromDatabase.favorite.width,
        headerName: t('admin.reports.columns.favorite'),
        valueGetter: (params) => {
          return params.row.favoriteId !== null;
        },
        renderCell: ({ row }) => {
          return (
            <div>
              <Button
                className="button icon"
                title={t('global.favorite')}
                onClick={(e) => {
                  e.stopPropagation();
                  handleUpdateFavorite(e, row.id)
                }}
              >
                <span
                  className={"material-icons"}
                  style={{
                    textAlign: 'left',
                    fontSize: '20px',
                    padding: '0 0px',
                    color: row.favoriteId === null ? 'rgb(var(--nofavorite-color))' : 'rgb(var(--favorite-color))'
                  }}
                >
                  {row.favoriteId === null ? 'star_border' : 'star'}
                </span>
              </Button>
            </div>
          )
        }
      },
      {
        sortable: true,
        field: 'type',
        type: 'singleSelect',
        hide: reportColumnsFromDatabase.type ? reportColumnsFromDatabase.type.hide : false,
        width: reportColumnsFromDatabase.type ? reportColumnsFromDatabase.type.width : 70,
        headerName: t('admin.reports.columns.type'),
        valueOptions: [
          'PCs',
          'Mobiles',
          'Disks'
        ],
        valueGetter: (params) => {
          //return params.row.type;
          switch (params.row.type) {
            case devicesTypeValues.PCs: {
              return 'PCs';
            }

            case devicesTypeValues.mobiles: {
              return 'Mobiles';
            }

            case devicesTypeValues.disks: {
              return 'Disks';
            }
          }
        },
        renderCell: ({ row }) => {
          switch (row.type) {
            case devicesTypeValues.PCs: {
              return (
                <span
                  className="material-icons"
                  title={t('scenarios.devicesType_PCs')}
                  style={{ height: 'auto', cursor: 'help' }}
                >laptop
                </span>
              )
            }
              break;

            case devicesTypeValues.mobiles: {
              return (
                <span
                  className="material-icons"
                  title={t('scenarios.devicesType_mobiles')}
                  style={{ height: 'auto', cursor: 'help' }}
                >phone_iphone
                </span>
              )
            }
              break;

            case devicesTypeValues.disks: {
              return (
                <span
                  className="material-icons"
                    title={t('scenarios.devicesType_disks')}
                  style={{ height: 'auto', cursor: 'help' }}
                >album
                </span>
              )
            }
              break;

            default: {
              return (
                <></>
              )
            }
              break;
          }
        }
      },
      {
        field: 'name',
        hide: reportColumnsFromDatabase.name.hide,
        width: reportColumnsFromDatabase.name.width,
        headerName: t('admin.reports.columns.name')
      },
      {
        field: 'template',
        hide: reportColumnsFromDatabase.template.hide,
        width: reportColumnsFromDatabase.template.width,
        headerName: t('admin.reports.columns.template'),
        valueGetter: (params) => {
          return params.row.templateTxt;
        },
        renderCell: ({ row }) => {
          return (row.templateTxt)
        }
      },
      {
        field: 'version',
        hide: reportColumnsFromDatabase.version && reportColumnsFromDatabase.version.hide || false,
        width: reportColumnsFromDatabase.version && reportColumnsFromDatabase.version.width || 160,
        headerName: t('admin.reports.columns.version'),
        valueGetter: (params) => {
          return params.row.version;
        },
        renderCell: ({ row }) => {
          return (row.version)
        }
      },
      {
        field: 'format',
        type: 'singleSelect',
        hide: reportColumnsFromDatabase.format.hide,
        width: reportColumnsFromDatabase.format.width,
        headerName: t('admin.reports.columns.format'),
        valueOptions: [
          'XML',
          'CSV',
          'HTML',
          'PDF'
        ],
        valueGetter: (params) => {
          return params.row.format.toUpperCase();
        },
        renderCell: ({ row }) => {
          return (row.format.toUpperCase())
        }
      },
      {
        field: 'language',
        type: 'singleSelect',
        hide: reportColumnsFromDatabase.language.hide,
        width: reportColumnsFromDatabase.language.width,
        headerName: t('admin.reports.columns.language'),
        valueOptions: [
          t('admin.reports.language.english'),
          t('admin.reports.language.french'),
          t('admin.reports.language.dutch')
        ],
        valueGetter: (params) => {
          let languageText = "";
          switch (params.row.language) {
            default:
            case 'en':
              languageText = t('admin.reports.language.english')
              break;

            case 'fr':
              languageText = t('admin.reports.language.french')
              break;

            case 'es':
              languageText = t('admin.reports.language.spanish')
              break;

            case 'nl':
              languageText = t('admin.reports.language.dutch')
              break;
          }
          return (languageText);;
        },
        // renderCell: ({ row }) => {
        //   let languageText = "";
        //   switch (row.language) {
        //     default:
        //     case 'en':
        //       languageText = t('admin.reports.language.english')
        //       break;

        //     case 'fr':
        //       languageText = t('admin.reports.language.french')
        //       break;

        //     case 'es':
        //       languageText = t('admin.reports.language.spanish')
        //       break;

        //     case 'nl':
        //       languageText = t('admin.reports.language.dutch')
        //       break;
        //   }
        //   return (languageText);
        // }
      },
      {
        field: 'pageSize',
        hide: reportColumnsFromDatabase.pageSize.hide,
        width: reportColumnsFromDatabase.pageSize.width,
        headerName: t('admin.reports.columns.pageSize'),
        valueGetter: (params) => {
          if (params.row.format.toUpperCase() === "PDF")
            return (params.row.pageSize.toUpperCase())
          else
            return "N/A";
        },
        // renderCell: ({ row }) => {
        //   if (row.format.toUpperCase() === "PDF")
        //     return (row.pageSize.toUpperCase())
        //   else
        //     return "N/A";
        // }
      },
      {
          field: 'orientation',
          hide: reportColumnsFromDatabase.orientation.hide,
          width: reportColumnsFromDatabase.orientation.width,
          headerName: t('admin.reports.columns.orientation'),
          valueGetter: (params) => {
            if (params.row.format.toUpperCase() === "PDF")
              return (params.row.orientation ? t('admin.reports.orientation.'+params.row.orientation).toUpperCase() : t('admin.reports.orientation.portrait').toUpperCase())
            else
              return "N/A";
          }         
        },
        {
        field: 'sharingOptions',
        type: 'singleSelect',
        hide: reportColumnsFromDatabase.sharingOptions.hide,
        width: reportColumnsFromDatabase.sharingOptions.width,
        headerName: t('admin.reports.columns.sharingOptions'),
        valueOptions: [
          t('scenarios.no_one'),
          t('scenarios.everyone'),
          t('scenarios.allStAdmins'),
          t('scenarios.allGroupAdmins'),
          t('scenarios.allGroupUsers')
        ],
        valueGetter: (params) => {
          let sharedWithText = "?";

          switch (params.row.sharingOptions) {
            case sharingValues.noOne:
              sharedWithText = t('scenarios.no_one');
              break;

            case sharingValues.everyone:
              sharedWithText = t('scenarios.everyone');
              break;

            case sharingValues.allStAdmins:
              sharedWithText = t('scenarios.allStAdmins');
              break;

            case sharingValues.allGroupAdmins:
              sharedWithText = t('scenarios.allGroupAdmins');
              break;

            case sharingValues.allGroupUsers:
              sharedWithText = t('scenarios.allGroupUsers');
              break;

            default:
              sharedWithText = "?";
          }
          return (sharedWithText)
        },
        // renderCell: ({ row }) => {
        //   let sharedWithText = "?";

        //   switch (row.sharingOptions) {
        //     case sharingValues.noOne:
        //       sharedWithText = t('scenarios.no_one');
        //       break;

        //     case sharingValues.everyone:
        //       sharedWithText = t('scenarios.everyone');
        //       break;

        //     case sharingValues.allStAdmins:
        //       sharedWithText = t('scenarios.allStAdmins');
        //       break;

        //     case sharingValues.allGroupAdmins:
        //       sharedWithText = t('scenarios.allGroupAdmins');
        //       break;

        //     case sharingValues.allGroupUsers:
        //       sharedWithText = t('scenarios.allGroupUsers');
        //       break;

        //     default:
        //       sharedWithText = "?";
        //   }
        //   return (sharedWithText)
        // }
      },
      {
        field: 'group',
        hide: reportColumnsFromDatabase.group.hide,
        width: reportColumnsFromDatabase.group.width,
        headerName: t('admin.reports.columns.group'),
        valueGetter: (params) => {
          if (params.row.groupName && params.row.sharingOptions >= sharingValues.allGroupAdmins)
            return (params.row.groupName)
          return "";
        }
        // renderCell: ({ row }) => {
        //   if (row.groupName && row.sharingOptions >= sharingValues.allGroupAdmins)
        //     return (row.groupName)
        //   return "";
        // }
      },
      {
        field: 'dateFormat',
        type: 'singleSelect',
        valueOptions: [
          'YYYYMMDD HHMMSS',
          'MMDDYYYY HHMMSS',
          'DDMMYYYY HHMMSS'
        ],
        hide: reportColumnsFromDatabase.dateFormat.hide,
        width: reportColumnsFromDatabase.dateFormat.width,
        headerName: t('admin.reports.columns.dateFormat')
      },
      {
        field: 'outputFileName',
        hide: reportColumnsFromDatabase.outputFileName.hide,
        width: reportColumnsFromDatabase.outputFileName.width,
        headerName: t('admin.reports.columns.outputFileName'),
        valueGetter: (params) => {
          if (params.row.outputFileName !== null)
            return (params.row.outputFileName)
          else
            return "";
        }
        // renderCell: ({ row }) => {
        //   if (row.outputFileName !== null)
        //     return (row.outputFileName)
        //   else
        //     return (
        //       <span style={{ fontStyle: 'italic' }}></span>
        //     );
        // }
      },
      {
        field: 'creator',
        hide: reportColumnsFromDatabase.creator.hide,
        width: reportColumnsFromDatabase.creator.width,
        headerName: t('admin.reports.columns.creator'),
        valueGetter: (params) => {
          return params.row.creator;
        }

        // renderCell: ({ row }) => {
        //   return (row.creator)
        // }
      },
      {
        field: 'creationDate',
        hide: reportColumnsFromDatabase.creationDate && reportColumnsFromDatabase.creationDate.hide,
        width: reportColumnsFromDatabase.creationDate && reportColumnsFromDatabase.creationDate.width,
        headerName: t('admin.reports.columns.creationDate'),
        align: 'left',
        headerAlign: 'left',
        type: 'date',
        // valueGetter: (params) => {
        //     const options = {
        //       year: 'numeric',
        //       month: '2-digit',
        //       day: '2-digit',
        //       hour: 'numeric',
        //       minute: '2-digit'
        //     };
        //   if (params.row.creationDate && params.row.creationDate !== '')
        //     return new Date(params.row.creationDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
        //   else
        //     return '...';
        // },
        renderCell: ({ row }) => {
          if (row && row.creationDate && row.creationDate !== '') {
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: '2-digit'
            };

            const lastTxt = new Date(row.creationDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
            return (
              <div>
                {lastTxt}
              </div>
            )
          }
          return (
            <div>
              ...
            </div>
          )
        }
      },
      {
        field: 'lastEditionUser',
        hide: reportColumnsFromDatabase.lastEditionUser && reportColumnsFromDatabase.lastEditionUser.hide,
        width: reportColumnsFromDatabase.lastEditionUser && reportColumnsFromDatabase.lastEditionUser.width,
        headerName: t('admin.reports.columns.lastEditionUser'),
        valueGetter: (params) => {
          return params.row.lastUser;
        },
        // renderCell: ({ row }) => {
        //   return (row.lastUser)
        // }
      },
      {
        field: 'lastEditionDate',
        hide: reportColumnsFromDatabase.lastEditionDate && reportColumnsFromDatabase.lastEditionDate.hide,
        width: reportColumnsFromDatabase.lastEditionDate && reportColumnsFromDatabase.lastEditionDate.width,
        headerName: t('admin.reports.columns.lastEditionDate'),
        align: 'left',
        headerAlign: 'left',
        type: 'date',
        // valueGetter: (params) => {
        //     const options = {
        //       year: 'numeric',
        //       month: '2-digit',
        //       day: '2-digit',
        //       hour: 'numeric',
        //       minute: '2-digit'
        //     };
        //   if (params.row.lastEditionDate && params.row.lastEditionDate !== '')
        //     return new Date(params.row.lastEditionDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
        //   else
        //     return '...';
        // },
        renderCell: ({ row }) => {
          if (row && row.lastEditionDate) {
            const options = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: 'numeric',
              minute: '2-digit'
            };

            const lastTxt = new Date(row.lastEditionDate).toLocaleDateString(settings.lang ? settings.lang : 'en', options);
            return (
              <div>
                {lastTxt}
              </div>
            )
          }
          return (
            <div>
              ...
            </div>
          )
        }
      },
      {
          field: 'percentUsage',
          hide: reportColumnsFromDatabase.percentUsage ? reportColumnsFromDatabase.percentUsage.hide : false,
          width: reportColumnsFromDatabase.percentUsage ? reportColumnsFromDatabase.percentUsage.width : 350,
          headerName: t('admin.reports.columns.percentUsage'),
          valueGetter: (params) => {
            if (params.row.percentUsageText)
              return (params.row.percentUsageText)
            return "";
          }
        },
        {
        field: 'actions',
        headerName: 'Actions',
        hide: reportColumnsFromDatabase.actions.hide,
        width: reportColumnsFromDatabase.actions.width,

        sortable: false,
        filterable: false,

        align: 'right',
        headerAlign: 'right',

        renderCell: ({ row }) => {

          // console.log("251 - row=", row);
          let disabled = row.sharingOptions === sharingValues.everyone && user.roleId > roles.stAdmin;
          if (!disabled) {
            if (user.id !== row.owner && row.allowModifications !== true)
              disabled = true;
          }

          if (user.roleId === roles.dashboardSuperAdmin)
            disabled = false;

          return (
            <div>
              <Button
                className="button icon"
                title={t('global.duplicate')}
                onClick={() => handleDuplicate(row)}
              >
                <span className="material-icons-outlined" style={{ fontSize: '20px', padding: '0 2px' }}>copy</span>
              </Button>

              <Button
                title={t('global.update')}
                style={{ minWidth: 'unset' }}
                onClick={() => setSelectedReport(row)}
                disabled={loading || disabled}
              >
                <span className="material-icons-outlined" style={{ color: '#222' }}>edit</span>
              </Button>
              <Button
                disabled={loading || disabled}
                title={t('global.delete')}
                style={{ minWidth: 'unset' }}
                onClick={() => handleDelete(row)}
              >
                <span className="material-icons-outlined" style={{ color: '#f22' }}>delete</span>
              </Button>
            </div>
          )
        }
  }
    ] // Keep columns order between sessions
      .sort((a, b) => {
        if (reportColumnsFromDatabase[a.field] && reportColumnsFromDatabase[b.field])
          return reportColumnsFromDatabase[a.field].order - reportColumnsFromDatabase[b.field].order;
        return -1;
      });
  }
  else {

    columns = [ // default visible width: 1650
    {
      field: 'id',
      headerName: 'ID',
        hide: reportColumnsFromDatabase.id.hide,
      filterable: false,
        width: reportColumnsFromDatabase.id.width
    },
    {
          // sortable: false,
      field: 'enabled',
      type: 'activeFilter',
        hide: reportColumnsFromDatabase.enabled.hide,
        width: reportColumnsFromDatabase.enabled.width,
      headerName: t('admin.reports.columns.active'),

      renderCell: ({ row }) => {
        const icon = (
          <svg viewBox="0 0 10 10" height="100%" width="100%" fill="#fff">
            <circle r={3.5} cx={5} cy={5} />
          </svg>
        );

        return (
          <Switch
            disabled={loading || (row.sharingOptions === sharingValues.everyone && user.roleId > roles.stAdmin)}
            checked={row.enabled}
            onChange={() => toggleActivated(row)}
            offHandleColor="#888" onHandleColor="#080"

            checkedIcon={null} uncheckedIcon={null}
            checkedHandleIcon={icon} uncheckedHandleIcon={icon}
          />
        );
      }
    },
    {
          // sortable: false,
      field: 'favorite',
      // type: 'activeFilter',
        hide: reportColumnsFromDatabase.favorite.hide,
        width: reportColumnsFromDatabase.favorite.width,
      headerName: t('admin.reports.columns.favorite'),
        valueGetter: (params) => {
          return params.row.favoriteId !== null;
        },
      renderCell: ({ row }) => {
        return (
          <div>
            <Button
              className="button icon"
              title={t('global.favorite')}
              onClick={(e) => {
                e.stopPropagation();
                handleUpdateFavorite(e, row.id)
              }}
            >
              <span
                className={"material-icons"}
                style={{
                  textAlign: 'left',
                  fontSize: '20px',
                  padding: '0 0px',
                  color: row.favoriteId === null ? 'rgb(var(--nofavorite-color))' : 'rgb(var(--favorite-color))'
                }}
              >
                {row.favoriteId === null ? 'star_border' : 'star'}
              </span>
            </Button>
          </div>
        )
      }
    },
    {
          sortable: true,
          field: 'type',
          type: 'singleSelect',
          hide: reportColumnsFromDatabase.type ? reportColumnsFromDatabase.type.hide : false,
          width: reportColumnsFromDatabase.type ? reportColumnsFromDatabase.type.width : 70,
          headerName: t('admin.reports.columns.type'),
          valueOptions: [
            'PCs',
            'Mobiles',
            'Disks'
          ],
          valueGetter: (params) => {
            //return params.row.type;
            switch (params.row.type) {
              case devicesTypeValues.PCs: {
                return 'PCs';
              }

              case devicesTypeValues.mobiles: {
                return 'Mobiles';
              }

              case devicesTypeValues.disks: {
                return 'Disks';
              }
            }
          },
          renderCell: ({ row }) => {
            switch (row.type) {
              case devicesTypeValues.PCs: {
                return (
                  <span
                    className="material-icons"
                    title={t('scenarios.devicesType_PCs')}
                    style={{ height: 'auto', cursor: 'help' }}
                  >laptop
                  </span>
                )
              }
                break;

              case devicesTypeValues.mobiles: {
                return (
                  <span
                    className="material-icons"
                    title={t('scenarios.devicesType_mobiles')}
                    style={{ height: 'auto', cursor: 'help' }}
                  >phone_iphone
                  </span>
                )
              }
                break;

              case devicesTypeValues.disks: {
                return (
                  <span
                    className="material-icons"
                    title={t('scenarios.devicesType_PCs')}
                    style={{ height: 'auto', cursor: 'help' }}
                  >album
                  </span>
                )
              }
                break;

              default: {
                return (
                  <></>
                )
              }
                break;
            }
          }
        },
        {
      field: 'name',
        hide: reportColumnsFromDatabase.name.hide,
        width: reportColumnsFromDatabase.name.width,
      headerName: t('admin.reports.columns.name')
    },
    {
      field: 'template',
        hide: reportColumnsFromDatabase.template.hide,
        width: reportColumnsFromDatabase.template.width,
      headerName: t('admin.reports.columns.template'),
      renderCell: ({ row }) => {
        return (row.templateTxt)
      }
    },
    {
          field: 'version',
          hide: reportColumnsFromDatabase.version && reportColumnsFromDatabase.version.hide || false,
          width: reportColumnsFromDatabase.version && reportColumnsFromDatabase.version.width || 160,
          headerName: t('admin.reports.columns.version'),
          valueGetter: (params) => {
            return params.row.version;
          },
          renderCell: ({ row }) => {
            return (row.version)
          }
        },
        {
      field: 'format',
        hide: reportColumnsFromDatabase.format.hide,
        width: reportColumnsFromDatabase.format.width,
      headerName: t('admin.reports.columns.format'),
      renderCell: ({ row }) => {
        return (row.format.toUpperCase())
      }
    },
    {
      field: 'language',
        hide: reportColumnsFromDatabase.language.hide,
        width: reportColumnsFromDatabase.language.width,
      headerName: t('admin.reports.columns.language'),
      renderCell: ({ row }) => {
        let languageText = "";
        switch (row.language) {
          default:
          case 'en':
            languageText = t('admin.reports.language.english')
            break;

          case 'fr':
            languageText = t('admin.reports.language.french')
            break;

          case 'es':
            languageText = t('admin.reports.language.spanish')
            break;

          case 'nl':
            languageText = t('admin.reports.language.dutch')
            break;
        }
        return (languageText);
      }
    },
    {
      field: 'pageSize',
        hide: reportColumnsFromDatabase.pageSize.hide,
        width: reportColumnsFromDatabase.pageSize.width,
      headerName: t('admin.reports.columns.pageSize'),
      renderCell: ({ row }) => {
        if (row.format.toUpperCase() === "PDF")
          return (row.pageSize.toUpperCase())
        else 
          return "N/A";
      }
    },
    {
          field: 'orientation',
          hide: reportColumnsFromDatabase.orientation.hide,
          width: reportColumnsFromDatabase.orientation.width,
          headerName: t('admin.reports.columns.orientation'),
          valueGetter: (params) => {
            if (params.row.format.toUpperCase() === "PDF")
              return (params.row.orientation.toUpperCase())
            else
              return "N/A";
          }         
        },
        {
      field: 'sharingOptions',
        hide: reportColumnsFromDatabase.sharingOptions.hide,
        width: reportColumnsFromDatabase.sharingOptions.width,
      headerName: t('admin.reports.columns.sharingOptions'),
      renderCell: ({ row }) => {
        let sharedWithText = "?";

        switch (row.sharingOptions) {
            case sharingValues.noOne:
            sharedWithText = t('scenarios.no_one');
            break;

            case sharingValues.everyone:
            sharedWithText = t('scenarios.everyone');
            break;

            case sharingValues.allStAdmins:
            sharedWithText = t('scenarios.allStAdmins');
            break;

            case sharingValues.allGroupAdmins:
            sharedWithText = t('scenarios.allGroupAdmins');
            break;

            case sharingValues.allGroupUsers:
            sharedWithText = t('scenarios.allGroupUsers');
            break;

          default:
            sharedWithText = "?";
        }
        return (sharedWithText)
      }
    },
    {
      field: 'dateFormat',
        hide: reportColumnsFromDatabase.dateFormat.hide,
        width: reportColumnsFromDatabase.dateFormat.width,
      headerName: t('admin.reports.columns.dateFormat')
    },
    {
      field: 'outputFileName',
        hide: reportColumnsFromDatabase.outputFileName.hide,
        width: reportColumnsFromDatabase.outputFileName.width,
      headerName: t('admin.reports.columns.outputFileName'),
      renderCell: ({ row }) => {
        if (row.outputFileName !== null)
          return (row.outputFileName)
        else
          return (
            <span style={{ fontStyle: 'italic' }}></span>
          );
      }
    },
    {
      field: 'creator',
        hide: reportColumnsFromDatabase.creator.hide,
        width: reportColumnsFromDatabase.creator.width,
      headerName: t('admin.reports.columns.creator'),
          // valueGetter: (params) => {
          //   return params.row.creator;
          // }
        valueGetter: (params) => {
            // console.log("635 - params.row=", params.row);
            if (
              (user.roleId <= roles.stAdmin) ||
              (user.roleId > roles.stAdmin && params.row.creatorRole > roles.stAdmin)
            ) {
              if (params.row.creator.includes('DEMO_USER_$'))
                return 'DEMO_USER';
          return params.row.creator;
      }
            return "";
          }
        // renderCell: ({ row }) => {
        //   return (row.creator)
        // }
    },
    {
      field: 'actions',
      headerName: 'Actions',
        hide: reportColumnsFromDatabase.actions.hide,
        width: reportColumnsFromDatabase.actions.width,

      sortable: false,
      filterable: false,

      align: 'right',
      headerAlign: 'right',

      renderCell: ({ row }) => {

        // console.log("251 - row=", row);
        let disabled = row.sharingOptions === sharingValues.everyone && user.roleId > roles.stAdmin;
        if (!disabled) {
          if (user.id !== row.owner && row.allowModifications !== true)
            disabled = true;
        }

        if (user.roleId === roles.dashboardSuperAdmin)
          disabled = false;
        
        return (
        <div>
          <Button
            className="button icon"
            title={t('global.duplicate')}
            onClick={() => handleDuplicate(row)}
          >
            <span className="material-icons-outlined" style={{ fontSize: '20px', padding: '0 2px' }}>copy</span>
          </Button>

          <Button
            title={t('global.update')}
            style={{ minWidth: 'unset' }}
            onClick={() => setSelectedReport(row)}
              disabled={loading || disabled}
          >
            <span className="material-icons-outlined" style={{ color: '#222' }}>edit</span>
          </Button>
          <Button
              disabled={loading || disabled}
            title={t('global.delete')}
            style={{ minWidth: 'unset' }}
            onClick={() => handleDelete(row)}
          >
            <span className="material-icons-outlined" style={{ color: '#f22' }}>delete</span>
          </Button>
        </div>
      )
    }
    }
  ] // Keep columns order between sessions
        //.sort((a, b) => reportColumnsFromDatabase[a.field].order - reportColumnsFromDatabase[b.field].order);
        .sort((a, b) => {
          if (reportColumnsFromDatabase[a.field] && reportColumnsFromDatabase[b.field])
            return reportColumnsFromDatabase[a.field].order - reportColumnsFromDatabase[b.field].order;
          return -1;
        });
    }
  }


  const toggleActivated = (rep) => {
    setLoading(true);

    rep.enabled = !rep.enabled;
    const report = { id: rep.id, skip: true, enabled: rep.enabled };

    update({ type: 'report', report }).then(res => {
      setLoading(false);
      if (!res.success) {
        rep.enabled = !rep.enabled; // revert switch state if error
        return toast(decodeHTMLEntities(t('admin.reports.errors.' + res, { name: rep.name })), { type: 'error' });
      }

      toast(decodeHTMLEntities(t('admin.reports.' + (res.report.enabled ? 'activated' : 'deactivated'), { name: rep.name })), { type: 'success' });
    });
  };


  const handleDelete = (rep) => {
    // const input = window.prompt(t('admin.locations.delete.confirm')+ ' ('+loc.label+')');
    // const input = window.prompt(t('admin.reports.delete.confirm', { name: rep.name }))

    const newText = rep.name.replace(/ /g, ' ');

    Swal.fire({
      allowOutsideClick: false,
      title: t('global.dialog_title'),
      html: t('admin.reports.delete.confirm', { name: newText }),
      input: "text",
      showCancelButton: true,
      confirmButtonText: t("global.ok"),
      cancelButtonText: t("global.cancel"),
      inputValidator: (value) => {
        const newValue = value.replace(/ /g, ' ');
        const newName = rep.name.replace(/ /g, ' ');

        if (newValue != newName && value != rep.name && newValue != rep.name) {   // CHECK loc.label === value
          return t('admin.reports.delete.validation');
        }
        return "";
        },
      customClass: {
        confirmButton: 'confirm-button-class',
        title: 'title-class',
        icon: 'icon-class'
        }
    }).then((value) => {
      // console.log("913 - value=", value);

      if (value && value.isConfirmed) {
        const newValue = value && value.value.replace(/ /g, ' ');
        const newName = rep && rep.name && rep.name.replace(/ /g, ' ');

        if (newValue === newName || value === rep.name || newValue === rep.name) {
      setLoading(true);

      remove({ type: 'report', id: rep.id }).then(res => {
        setLoading(false);
            if (!res.success) {
              return toast(decodeHTMLEntities(t('admin.reports.errors.' + res, { name: rep.name })), { type: 'error' });
            }

        setReports(reports.filter(row => row.id !== rep.id));
            eventDispatch({ reportsStatus: 'force' });
            toast(decodeHTMLEntities(t('admin.reports.delete.success', { name: rep.name })), { type: 'success' });

      });
    }
        else {
          return toast(decodeHTMLEntities(t('admin.reports.errors.wrong')), { type: 'error' });
        }
      }
    });

    // if (input === rep.name) {
    //   setLoading(true);

    //   remove({ type: 'report', id: rep.id }).then(res => {
    //     setLoading(false);
    //     if (!res.success) return toast(t('admin.reports.errors.' + res, { name: rep.name }), { type: 'error' });

    //     setReports(reports.filter(row => row.id !== rep.id));
    //     toast(t('admin.reports.delete.success', { name: rep.name }), { type: 'success' });
    //     // appDispatch({ forceReload: true });
    //   });
    // }

    // else if (input) return toast(t('admin.reports.errors.wrong'), { type: 'error' });
  };


  const handleDuplicate = (reportSource) => {
    const name = reportSource.name;
    const report = { ...reportSource };

      report.name = name + ' - Copy';


    if (user.email.includes('DEMO_USER_$')) {
      report.groups = [];
      report.groups.push(user.groupId);
      report.sharingOptions = sharingValues.noOne;
    }
    else if (user.roleId > roles.stAdmin && report.sharingOptions === sharingValues.everyone) {
      report.groups = [];
      report.groups.push(user.groupId);
      report.sharingOptions = sharingValues.allGroupAdmins;
    }

    console.log("1266 - report=", report);

      create({ type: 'report', report }).then(res => {
        setLoading(false);
      if (!res.success) {
        return toast(decodeHTMLEntities(t('admin.reports.errors.' + res, { name: reportSource.name })), { type: 'error' });
      }

      eventDispatch({ reportsStatus: 'force' });
      toast(decodeHTMLEntities(t('admin.reports.duplicate.success', { name: reportSource.name })), { type: 'success' });
        setLoaded(false);
      });

    // const name = reportSource.name;
    // const report = { ...reportSource };
    // report.name = name + ' - Copy';

    // if (report.groups.length === 0)
    //   report.groups.push(user.groupId);
  };


  const handleUpdateFavorite = (e, report) => {
    e.preventDefault();

    const favorite = { reportId: report };
    let tmpArray = new Array();
    for (const rep of reports) {
      const tmRep = {
        ...rep
      }
      if (rep.id == report) {
        if (rep.favoriteId)
          tmRep.favoriteId = null;
        else
          tmRep.favoriteId = 'fake';
      }
      tmpArray.push(tmRep);
    }
    setReports(tmpArray);

    try {
      update({ type: 'favorite', favorite }).then(res => {
        // appDispatch({ forceReload: true, forceReloadScenario: true });
        eventDispatch({ reportsStatus: 'force' });

      });
    }
    catch (error) {
      console.log("681 - error=", error);
    }

    // const favorite = { reportId: report };
    // try {
    //   update({ type: 'favorite', favorite }).then(res => {

    //     eventDispatch({ refreshReports: true });

    //     getReports().then(rep => {
    //       if (rep && rep.success) {
    //         setReports(rep.reports);
    //       }
    //     });
    //   });
    // }
    // catch (error) {
    //   console.log("681 - error=", error);
    // }
  };



  const changeColumnsWidth = (col) => {
    const prev = JSON.stringify(reportColumnsFromDatabase);
    let newReportColumns = reportColumnsFromDatabase;
    newReportColumns[col.colDef.field].width = col.width;
    const next = JSON.stringify(newReportColumns);

    // console.log("823 - prev=", prev);
    // console.log("823 - next=", next);

    if (prev !== next) {
      updateReportColumnsOrder(newReportColumns);
      setReportColumnsFromDatabase(newReportColumns);

      const newUser = {
        ...user,
        reportColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }
  }


  const changeColumnsVisibility = (col) => {
    const prev = JSON.stringify(reportColumnsFromDatabase);
    let newReportColumns = reportColumnsFromDatabase;
    newReportColumns[col.colDef.field].hide = !col.isVisible;
    const next = JSON.stringify(newReportColumns);

    if (prev !== next) {
      updateReportColumnsOrder(newReportColumns);
      setReportColumnsFromDatabase(newReportColumns);

      const newUser = {
        ...user,
        reportColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }
  }


  const changeColumnsOrder = (reorderedColumn, oldIndex, targetIndex) => {

    const prev = JSON.stringify(reportColumnsFromDatabase);
    let ecart = targetIndex - oldIndex;
    if (ecart > 0)
      ecart = ecart + 0.5;
    else
      ecart = ecart - 0.5;

    let newReportColumns = {};
    for (const columnName in reportColumnsFromDatabase) {
      const column = reportColumnsFromDatabase[columnName];

      newReportColumns[columnName] = reportColumnsFromDatabase[columnName];

      if (columnName === reorderedColumn)
        newReportColumns[columnName].order = newReportColumns[columnName].order + ecart;
      }

    const orderedKeys = Object.keys(newReportColumns)
      .sort((a, b) => {
        return newReportColumns[a].order > newReportColumns[b].order ? 1 : -1;
      });

    let i = 1;
    for (const key of orderedKeys) {
      newReportColumns[key].order = i;
      i++;
        }

    const next = JSON.stringify(newReportColumns);

    if (prev !== next) {
      updateReportColumnsOrder(newReportColumns);
      setReportColumnsFromDatabase(newReportColumns);

      const newUser = {
        ...user,
        reportColumnsOrder: next
      }
      appDispatch({ user: newUser });
    }

    setReordering(null);
    setReorderedColumn("");
    setOldIndex(null);
    setTargetIndex(null);
  }


  const selectedOption = () => {
    if (!selectedReport) return null;

    // determine if user wants to create or edit a location
    return selectedReport.id ? (
      // <div>

      // </div>
      <Update
        // reports={reports}
        // setReports={setReports}
        selectedReport={selectedReport}
        setSelectedReport={setSelectedReport}
        setLoadedReport={setLoaded}
      />
    ) : (
      <Create
        // reports={reports}
        // setReports={setReports}
        setSelectedReport={setSelectedReport}
        setLoadedReport={setLoaded}
      />
    )
  };


  const rowsToPrint = () => {
    const filtered = model.filtered ?? reports;

    // .slice() creates a new array
    const rows = filtered.slice().filter(rep => (
      model.selected.length > 0 ? model.selected.includes(rep.id) : rep.id > 0
    ));
    return rows;
  };


  const updateRowsAndPrint = () => {
    // console.log("292 - updateRowsAndPrint=", model, Array.from(apiRef.current.getVisibleRowModels().values()));
    setModel(
      { ...model, filtered: Array.from(apiRef.current.getVisibleRowModels().values()) },
      () => window.print()
    );
  };



  // console.log("931 - reorderedColumns=", reorderedColumns);
  // console.log("1364 - reportColumnsFromDatabase=", reportColumnsFromDatabase);
  // console.log("1469 - columns=", columns);


  /*newFilteredRows*/
  let filteredRows = [];

  let tmpStr = 'admin.reports.modeReports.' + modeReports;
  let modeReportsText = t(tmpStr);
  
  let totalReportsCount = reports.length;
  const filteredReports = _.filter(reports, report => {
    let keepIt = true;

    switch (modeReports) {
      case "all_reports":
        return true;
        break;

      case "myGroup_reports": {
        if (report.groups && report.groups.length > 0) {
          let test = report.groups.find(element => {
            return (element === user.groupId);
          })
          return (test);
        }
        break;
      }

      case "myShared_reports": {
        if (user.id === report.owner && report.sharingOptions !== sharingValues.noOne)
          return true;
        break;
      }

      case "myPrivate_reports": {
        if (user.id === report.owner && report.sharingOptions === sharingValues.noOne)
          return true;
        break;
      }

      case "sft_reports": {
        if (user.roleId <= roles.stAdmin && report.sharingOptions === sharingValues.allStAdmins)
          return true;
        break;
      }

      case "allGroups_reports": {
        if (
          user.roleId <= roles.stAdmin && report.groups && report.groups.length > 0 //(          
        )
          return true;
        break;
      }

      case "currentGroups_reports": {

        if (user.roleId <= roles.stAdmin && report.groups && report.groups.length > 0 && selected && selected.groups) {
             
          let test = selected.groups.find(element => {
            return (element.value === report.groups[0]);
          })
          return (test);
        }
        return false;
        break;
      }

      default:
        return false;
    }
    return false;
  });
  let filteredReportsCount = filteredReports.length;



  return (
    <div className="admin reports">
      <DataGridPro
        // disableVirtualization={true}

        apiRef={apiRef}
        loading={loading}
        // checkboxSelection
        disableSelectionOnClick

        pageSize={settings.pageSize}
        pagination={settings.pagination}
        rows={filteredReports}
        columns={columns}

        onSelectionModelChange={selected => setModel({ ...model, selected })}
        columnTypes={{ activeFilter: activeGridFilter(t, GridFilterInputValue) }}
        onPageSizeChange={pageSize => changeSettings(t, 'pageSize', pageSize, settings, appDispatch)}

        onColumnWidthChange={(params, event) => {
          changeColumnsWidth(params);
        }}
        onColumnVisibilityChange={(params, event) => {
          changeColumnsVisibility(params);
        }}
        onColumnOrderChange={(params, event) => {
          // console.log("1422 - params=", oldIndex, targetIndex, params);
          if (oldIndex === null) {
            setReorderedColumn(params.field)
            setOldIndex(params.oldIndex);
          }

          setTargetIndex(params.targetIndex);
          // changeColumnsOrder(params);
        }}

        onColumnHeaderDragStart={(params, event) => {
          // console.log("1427 - onColumnHeaderDragStart=", params);
        }}
        onColumnHeaderDragEnd={(params, event) => {
          // console.log("1430 - columnHeaderDragEnd=", params);
        }}

        getRowClassName={(params) => {
          return params.id === highlightedRow ? "highlight" : "";
        }}
        onRowClick={o => {
          if (o.id === highlightedRow)
            setHighlightedRow(null);
          else 
            setHighlightedRow(o.id)
        }}

        onRowDoubleClick={o => {
          const r = reports.find((reportElement) => {
            return reportElement.id === o.id;
          });

          if (r) {
            let disabled = r.sharingOptions === sharingValues.everyone && user.roleId > roles.stAdmin;
            if (!disabled) {
              if (user.id !== r.owner && r.allowModifications !== true)
                disabled = true;
            }

            if (user.roleId === roles.dashboardSuperAdmin)
              disabled = false;

            if (!disabled)
              setSelectedReport(r);
          }
        }}


        // onColumnWidthChange={col => changeAdminColumns({
        //   column: col.colDef.field, columns: reportColumns, dispatch,
        //   view: 'report', type: 'width', value: col.width
        // })} // Save custom column width set by the user
        // onColumnVisibilityChange={col => changeAdminColumns({
        //   column: col.field, columns: reportColumns, dispatch,
        //   view: 'report', type: 'hide', value: !col.isVisible
        // })} // Save hidden column state set by the user
        // onColumnOrderChange={col => changeAdminColumns({
        //   column: col.field, columns: reportColumns, dispatch,
        //   view: 'report', type: 'order', value: { old: col.oldIndex, new: col.targetIndex }
        // })} // Save custom column order set by the user

        localeText={{
          ...(localStorage.getItem('lang') === 'fr' ? frFR : enUS).props.MuiDataGrid.localeText,
          ...translatedGridFilters(t)
        }}

        components={{
          ColumnSortedAscendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_upward
            </div>
          ),
          ColumnSortedDescendingIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks }}
            >
              arrow_downward
            </div>
          ),
          ColumnUnsortedIcon: () => (
            <div
              class='MuiSvgIcon-root MuiSvgIcon-fontSizeSmall material-icons'
              style={{ color: colors.softthinks, opacity: '0.4' }}
            >
              remove
            </div>
          ),

          LoadingOverlay,
          Toolbar: () => (
            <div className="content__header">

              {/* <h2>{t('admin.reports.title')}{'\u2000\u2013\u2000'}
                <span style={{ color: colors.softthinks }}>
                  {loading ? (t('global.loading') + '...') : apiRef.current.getVisibleRowModels().size}
                </span>
                <span style={{ color: '#999' }}>
                  {user.roleId <= roles.stAdmin && reportGeneratorData && reportGeneratorData.FileVersion && 
                    ('\u2000\u2013\u2000 (' +  t('global.reports_engine') + '\u2000' + t('global.version_letter') + reportGeneratorData.FileVersion + ')')
                  }
                </span>
              </h2> */}

              <h2>
                {user.roleId === roles.user && (
                  <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                    <ul className="dropdown__list" id="modeReports" style={{ fontSize: "15px" }}>
                      <li onClick={() => handleSetModeReports('all_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.all_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myGroup_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myGroup_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myShared_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myShared_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myPrivate_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myPrivate_reports')}
                      </li>
                    </ul>

                    <h2
                      className="dropdown__content"
                      style={{
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "0px",
                        marging: "0px 0px 8px 0px",
                        transition: "0.25s",
                        userSelect: "none",
                        textAlign: 'center'
                      }}
                      onClick={() => document.querySelector('#modeReports').classList.toggle('open')}
                    >
                      <span className="dropdown__open"> </span>
                      <span className="dropdown__open dropdown__title">{modeReportsText}</span>
                      <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
                    </h2>
                  </div>
                )}

                {user.roleId === roles.admin && (
                  <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                    <ul className="dropdown__list" id="modeReports" style={{ fontSize: "15px" }}>
                      <li onClick={() => handleSetModeReports('all_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.all_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myGroup_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myGroup_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myShared_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myShared_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myPrivate_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myPrivate_reports')}
                      </li>
                    </ul>

                    <h2
                      className="dropdown__content"
                      style={{
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "0px",
                        marging: "0px 0px 8px 0px",
                        transition: "0.25s",
                        userSelect: "none",
                        textAlign: 'center'
                      }}
                      onClick={() => document.querySelector('#modeReports').classList.toggle('open')}
                    >
                      <span className="dropdown__open"> </span>
                      <span className="dropdown__open dropdown__title">{modeReportsText}</span>
                      <span className="dropdown__open material-icons-round dropdown__arrow">expand_more</span>
                    </h2>
                  </div>
                )}

                {user.roleId <= roles.stAdmin && (
                  <div className={'dropdown'} style={{ display: "block", alignItems: 'center' }}>
                    <ul className="dropdown__list" id="modeReports" style={{ fontSize: "15px" }}>
                      <li onClick={() => handleSetModeReports('all_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.all_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('sft_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.sft_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('allGroups_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.allGroups_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('currentGroups_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.currentGroups_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myShared_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myShared_reports')}
                      </li>
                      <li onClick={() => handleSetModeReports('myPrivate_reports')} style={{ textAlign: 'center', padding: '8px 12px' }}>
                        {t('admin.reports.modeReports.myPrivate_reports')}
                      </li>
                    </ul>

                    <h2
                      className="dropdown__content"
                      style={{
                        display: "flex",
                        position: "relative",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: "0px",
                        marging: "0px 0px 8px 0px",
                        transition: "0.25s",
                        userSelect: "none",
                        textAlign: 'center'
                      }}
                      onClick={() => document.querySelector('#modeReports').classList.toggle('open')}
                    >
                      <span className="dropdown__open"> </span>
                      <span className="dropdown__open">{modeReportsText}</span>
                      <span
                        className="dropdown__open material-icons-round dropdown__arrow"
                        style={{ padding: "4px 0px 0px 0px" }}
                      >
                        expand_more
                      </span>
                    </h2>
                  </div>
                )}

                {'\u2000\u2000'}
                <span style={{ color: colors.softthinks, padding: "0px 0px 0px 0px" }}>
                  {/* {loading ? (t('global.loading') + '...') : apiRef.current.getVisibleRowModels().size} */}
                  {loading ? (t('global.loading') + '...') : ((modeReports === 'all_reports') ? '(' + totalReportsCount + ')' : '(' + filteredReportsCount + '/' + totalReportsCount + ')'  /*apiRef.current.getVisibleRowModels().size*/)}
                </span>
                <span style={{ color: '#999' }}>
                  {user.roleId <= roles.stAdmin && reportGeneratorData && reportGeneratorData.FileVersion &&
                    ('\u2000\u2013\u2000 (' + t('global.reports_engine') + '\u2000' + t('global.version_letter') + reportGeneratorData.FileVersion + ')')
                  }
                </span>
              </h2>


              <div className="options">
                <GridToolbarContainer>
                  <GridToolbarFilterButton />
                  <GridToolbarColumnsButton />
                </GridToolbarContainer>
                <span className="separation" />

                <div className="actions">
                  <Export
                    apiRef={apiRef}
                    loading={loading}
                    model={model}
                    setModel={setModel}
                  /> {/* Excel / PDF Download */}

                  <button title={t('global.actions.print')} className="button icon" onClick={updateRowsAndPrint} disabled={loading}>
                    <span className="material-icons-round">print</span> {/* Print */}
                  </button>

                </div>
                <span className="separation" />
                
                <Button
                  // disabled={user.email.includes('DEMO_USER_$')}
                  className="button"
                  onClick={() => setSelectedReport({})}
                  startIcon={<span className="material-icons-round">add_circle_outline</span>}
                >{t('admin.reports.create.button')}</Button>
              </div>
            </div>
          ),

          Footer: () => (
            <div className="datagrid__footer">
              <GridFooter />
              <div className="checkbox">
                <input
                  id="pagination"
                  type="checkbox"
                  defaultChecked={settings.pagination}
                  onChange={() => changeSettings(t, 'pagination', !settings.pagination, settings, appDispatch)}
                />
                <label htmlFor="pagination">PAGINATION</label>
              </div>
            </div>
          )
        }}
      />

      {selectedOption()}

      {(reports.length > 0) && <Print reports={rowsToPrint()} />}
    </div>
  );
}
